import { render } from "./ViewOffrePage.vue?vue&type=template&id=7d7d4186&ts=true"
import script from "./ViewOffrePage.vue?vue&type=script&lang=ts"
export * from "./ViewOffrePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__